window.WonderlyCarouselControls = {
  init(sliderId) {
    const slider = document.getElementById(`Slider-${sliderId}`);
    if (!slider) return;

    if (typeof slider.__wonderlyCarouselUpdate === 'function') {
      slider.__wonderlyCarouselUpdate();
      return;
    }

    const host = slider.closest('slider-component');
    const track = document.getElementById(`FeaturedCollectionProgressTrack-${sliderId}`);
    const bar = document.getElementById(`FeaturedCollectionProgress-${sliderId}`);
    const navOverlay = host?.querySelector('.wonderly-carousel__nav-overlay');
    const nav = host?.querySelector('.wonderly-carousel-nav');
    const desktopQuery = window.matchMedia('(min-width: 990px) and (pointer: fine)');

    const update = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const scrollable = maxScroll > 1;
      const showNav = scrollable && desktopQuery.matches;

      if (track) track.classList.toggle('is-hidden', !scrollable);
      if (navOverlay) navOverlay.classList.toggle('is-hidden', !showNav);
      if (nav) nav.classList.toggle('is-hidden', !showNav);

      if (bar) {
        if (!scrollable) {
          bar.style.width = '0%';
          return;
        }

        const fill = ((slider.scrollLeft + slider.clientWidth) / slider.scrollWidth) * 100;
        bar.style.width = `${fill}%`;
      }
    };

    const scheduleUpdate = () => {
      window.requestAnimationFrame(update);
    };

    slider.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    desktopQuery.addEventListener('change', scheduleUpdate);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleUpdate).observe(slider);
    }

    slider.__wonderlyCarouselUpdate = scheduleUpdate;
    scheduleUpdate();
  },

  scan(root = document) {
    root.querySelectorAll('[data-wonderly-carousel-id]').forEach((element) => {
      this.init(element.dataset.wonderlyCarouselId);
    });
  },
};

function bootWonderlyCarouselControls() {
  if (window.WonderlyCarouselControls) {
    window.WonderlyCarouselControls.scan();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootWonderlyCarouselControls);
} else {
  bootWonderlyCarouselControls();
}

window.addEventListener('load', bootWonderlyCarouselControls);

let wonderlyCarouselScanTimer;
const debouncedWonderlyCarouselScan = () => {
  window.clearTimeout(wonderlyCarouselScanTimer);
  wonderlyCarouselScanTimer = window.setTimeout(bootWonderlyCarouselControls, 100);
};

if (typeof MutationObserver !== 'undefined') {
  new MutationObserver(debouncedWonderlyCarouselScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
